import { createStyles, rule } from '../core';

var randomHexColor = function randomHexColor() {
  return '#' + ((Math.random() * 0xFFFFFF << 0).toString(16) + '0').slice(0, 6);
};
/**
 * ```js
 * import { outline } from 'pss'
 * ```
 *
 * prop         | css             | type                 | value | true       | false
 * :------------|:----------------|:---------------------|:------|:-----------|:--------
 * `outline`    | `outline`       | `String`, `'debug'`* | ✓     | —         | —
 *
 * \* Random hex color, useful for debugging layout
 *
 * ⚠️ This prop may not be filtered by CSS-in-JS libraries, so you may need to provide custom prop filtering.
 *
 * Related: {@link rule}.
 *
 * @param {Object} props
 *
 * @example
 * import { outline } from 'pss'
 *
 * const Box = styled.div`
 *   ${outline}
 * `
 *
 * @example
 * <Box outline='1px solid red' /> // → outline: 1px solid red
 */


export var outline = createStyles({
  outline: rule('outline', function (val) {
    return val === 'debug' ? "1px solid " + randomHexColor() : val;
  })
});